import { getMatchedLegRunIdsInRow, VehicleRowGroup } from 'src/pages/ConvenienceDispatches/adapter';

export type ResetTargets = {
  /** API へ送る legRun。重複排除済み */
  legRunIds: number[];
  /** 案件を持つ行の数。確認文と完了通知の「N件」はこれを使う */
  deletableRowCount: number;
};

/**
 * 「配車リセット（未割当に戻す）」の対象を、選択行から集める。
 *
 * 件数に選択行数を使わないのは、案件の無い行を選んでいても「N件削除します」と
 * 出てしまうため。実際に消える行だけを数える。
 */
export function collectResetTargets(
  selectedRowIds: Set<string>,
  rowGroups: VehicleRowGroup[],
): ResetTargets {
  const legRunIds = new Set<number>();
  let deletableRowCount = 0;

  rowGroups.forEach((group) => group.rows.forEach((row) => {
    if (!selectedRowIds.has(row.rowId)) return;
    const ids = getMatchedLegRunIdsInRow(row.source);
    if (ids.length === 0) return;
    deletableRowCount += 1;
    ids.forEach((id) => legRunIds.add(id));
  }));

  return { legRunIds: Array.from(legRunIds), deletableRowCount };
}
